module.exports = __webpack_public_path__ + "img/img31.bc8dfb28.png";